import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const SignInStack = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  minHeight: '100vh',
  zIndex: 0,
  '&::before': {
    content: '""',
    display: 'block',
    position: 'fixed',
    zIndex: -1,
    inset: 0,
    width: '100vw',
    height: '100vh',
    backgroundImage: 'url(/images/stockvault-beautiful-clouds131810.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
}));

const SignInContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  minHeight: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
}));

const FormSignInContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
}));

const FormControlContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  gap: '16px',
}));

const LogoContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '40vh',
  alignSelf: 'anchor-center',
  maxWidth: '100%',
}));

const SignInCard = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  overflow: 'auto',
  width: '100%',
  maxWidth: '450px',
  margin: '16px',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  backgroundColor: 'rgba(255, 255, 255, 1)',
  boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  ...theme.applyStyles('dark', {
    backgroundColor: 'hsl(220, 30%, 6%)',
  }),
}));

export {
  FormControlContainer,
  FormSignInContainer,
  LogoContainer,
  SignInStack,
  SignInCard,
  SignInContainer,
};
